import { render, staticRenderFns } from "./mainInfo.vue?vue&type=template&id=030a55d4&scoped=true&"
import script from "./mainInfo.vue?vue&type=script&lang=js&"
export * from "./mainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030a55d4",
  null
  
)

export default component.exports